<template>
    <div class="nav-bar">
        <BreadCrumb
            id="breadcrumb-container"
            class="breadcrumb-container"
        />
    </div>
</template>
<script>
import { defineComponent } from 'vue'
import BreadCrumb from '@/components/bread-crumb/Index.vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent ({
    components: { BreadCrumb },
    setup() {
        const store = useStore()
        const route = useRoute()
        const router = useRouter()
    }
})
</script>

<style lang="stylus" scoped>
    .nav-bar
        margin-left $sideBarWidth
</style>